import { useEffect } from 'react';
import { isEqual } from 'lodash-es';
import { useBookingContext } from 'src/widgets/BookingContext';
import { setNewCartItem } from 'src/state/booking/bookingReducer';
import useNewCartItem from './useNewCartItem';

export default function useUpdateNewCartItem(newItemDisablePaymentPlans: boolean) {
    const { newCartItem, selectedProducts, quantities, selectedTimeSlot, bookingDispatch } =
        useBookingContext();

    const selectedNewCartItem = useNewCartItem(
        selectedProducts,
        quantities,
        selectedTimeSlot?.products,
        newItemDisablePaymentPlans,
    );

    useEffect(() => {
        if (isEqual(selectedNewCartItem, newCartItem)) return;

        if (selectedNewCartItem) {
            bookingDispatch(setNewCartItem(selectedNewCartItem));
        } else {
            bookingDispatch(setNewCartItem(null));
        }
    }, [selectedNewCartItem, newCartItem, bookingDispatch]);
}
